import { catalogModule } from "@/modules/catalog";
import { dashboardModule } from "@/modules/dashboard";
import { docsModule } from "@/modules/docs";
import { contactsModule } from "@/modules/contacts";
import { gstModule } from "@/modules/gst";
import { inventoryModule } from "@/modules/inventory";
import { reportsModule } from "@/modules/reports";
import { settingsModule } from "@/modules/settings";
import { tasksModule } from "@/modules/tasks";
import { ordersModule } from "@/modules/orders";
import { warehousesModule } from "@/modules/warehouses";
import type { ModuleUi } from "@/modules/types";

/**
 * Every module that has a user interface.
 *
 * The one file a new module track has to touch outside its own directory,
 * and it touches it by one line. That is deliberate: nine tracks being built
 * at once cannot all be editing the same screen.
 */
const MODULES: ModuleUi[] = [
  dashboardModule,
  ordersModule,
  catalogModule,
  contactsModule,
  gstModule,
  inventoryModule,
  warehousesModule,
  tasksModule,
  reportsModule,
  docsModule,
  settingsModule,
];

const byId = new Map(MODULES.map((module) => [module.id, module]));

export function moduleUi(moduleId: string): ModuleUi | undefined {
  return byId.get(moduleId);
}
